'use client';

import { useEffect } from 'react';
import { RefreshCw, Home, AlertTriangle } from 'lucide-react';
import Link from 'next/link';
import Image from 'next/image';
import '@/styles/brutalist/error.css';

export default function Error({
  error,
  reset,
}: {
  error: Error & { digest?: string };
  reset: () => void;
}) {
  useEffect(() => {
    // Log the error to console (in production, send to error monitoring service)
    console.error('Application error:', error);
  }, [error]);

  return (
    <div className="error-page">
      <div className="error-container">
        <div className="error-logo">
          <Image
            src="/logo.svg"
            alt="Shipzy"
            width={140}
            height={40}
            className="mx-auto"
          />
        </div>

        <div className="error-icon">
          <AlertTriangle />
        </div>
        
        <h1 className="error-title">
          Something Went Wrong
        </h1>
        
        <p className="error-message">
          We encountered an unexpected error. Please try again or return to the homepage.
        </p>

        {error.digest && (
          <p className="error-id">
            Error ID: {error.digest}
          </p>
        )}

        <div className="error-actions">
          <button
            onClick={reset}
            className="error-button"
          >
            <RefreshCw className="w-4 h-4" />
            Try Again
          </button>
          
          <Link href="/" className="error-button error-button-primary">
            <Home className="w-4 h-4" />
            Go Home
          </Link>
        </div>
      </div>
    </div>
  );
}
